
define(
	'Digi.knowledge.knowledge'
,   [
		'Digi.knowledge.knowledge.View',
		'Utils'
	]
,   function (
		knowledgeView,
		Utils
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

			var userRole, profile, userRoleId, environment, config, validRoles, menuTitle, menuIndexPartner, menuIndexCustomer;
			var validRolesArray = new Array();
			try {
				profile = require('Profile.Model');
				userRole = profile.getInstance();
				userRoleId = userRole.attributes.userRole;

				environment = container.getComponent('Environment');
				config = environment.getConfig('digiConfigSettings');
				validRoles = config && config.knowledge && config.knowledge.validroles;

				menuIndexPartner = config && config.knowledge && config.knowledge.menuindexpartner;
				menuIndexPartner = menuIndexPartner ? menuIndexPartner : 7;

				menuIndexCustomer = config && config.knowledge && config.knowledge.menuindexcustomer;
				menuIndexCustomer = menuIndexCustomer ? menuIndexCustomer : 2;

				menuTitle = config && config.knowledge && config.knowledge.menutitle;
				menuTitle = menuTitle ? menuTitle : 'Knowledge';

				if(validRoles) {
					validRolesArray = validRoles.split(',');
				}
			} catch(e) {

			}

			if(userRoleId && validRolesArray && validRolesArray.length > 0) {
				var validRoleFound = validRolesArray.filter(function(el){return el == userRoleId});
				if(validRoleFound && validRoleFound.length > 0) {

					var MyAccountMenu = container.getComponent('MyAccountMenu');

					//Partner=1096,Customer=1048,Shop=1207
					var knowledgegroup;
					if(userRoleId == 1096) {
						knowledgegroup = {
			                id: 'KnowledgeHeader',
			                name: Utils.translate(menuTitle),
			                index: menuIndexPartner,
							url: 'knowledge'
			            }
					} else {
						knowledgegroup = {
			                id: 'KnowledgeHeader',
			                name: Utils.translate(menuTitle),
			                index: menuIndexCustomer,
							url: 'knowledge'
			            }
					}

		            MyAccountMenu.addGroup(knowledgegroup);

		            /*var KnowledgeEntry = {
		                id: 'knowledge'
		                , groupid: 'KnowledgeHeader'
		                , index: 1
		                , url: 'knowledge'
		                , name: Utils.translate(menuTitle)
		            }

		            MyAccountMenu.addGroupEntry(KnowledgeEntry);*/

					var pageType = container.getComponent('PageType');
					pageType.registerPageType({
						name: 'Knowledge',
						routes: ['knowledge'],
						view: knowledgeView,
						defaultTemplate: {
							name: 'digi_knowledge_knowledge.tpl',
							displayName: menuTitle
						}
					});
				}
			}

		}
	};
});
